import { getCdnUrl } from '../../helpers';
import FingoLogo from './images/logo_with_name.png';

const FingoHalloween = getCdnUrl('/common_assets/halloween_fingo_logo.png');
const FingoChile = getCdnUrl('/common_assets/logo_fingo_chilean_national_day.png');
const FingoChristmas = getCdnUrl('/common_assets/logo_fingo_christmas.png');

export { FingoLogo, FingoChile, FingoHalloween, FingoChristmas };
